import * as Bixby from '$/core';

export interface ForgotPasswordState {
  isLoading: boolean;
  error?: string;
  success: boolean;
}

export const FORGOT_PASSWORD_REQUEST_INPROGRESS = 'FORGOT_PASSWORD_REQUEST_INPROGRESS';
export const FORGOT_PASSWORD_REQUEST_SUCCESS = 'FORGOT_PASSWORD_REQUEST_SUCCESS';
export const FORGOT_PASSWORD_REQUEST_FAILURE = 'FORGOT_PASSWORD_REQUEST_FAILURE';

interface ForgotPasswordInProgress extends Bixby.Models.BixbyAction {
  type: typeof FORGOT_PASSWORD_REQUEST_INPROGRESS;
}

interface ForgotPasswordRequestSuccess extends Bixby.Models.BixbyAction {
  type: typeof FORGOT_PASSWORD_REQUEST_SUCCESS;
}

interface ForgotPasswordRequestFailure extends Bixby.Models.BixbyAction {
  type: typeof FORGOT_PASSWORD_REQUEST_FAILURE;
  payload: Bixby.Models.BixbyError;
}

export type ForgotPasswordActionTypes =
  | ForgotPasswordInProgress
  | ForgotPasswordRequestSuccess
  | ForgotPasswordRequestFailure;
